
export function videoReviewOpen() {
  const videosOpen = document.querySelectorAll('.jc-video-toggle');
  const videoModal = document.getElementById('video_review_modal');

  videosOpen.forEach(videoOpen => {
    videoOpen.addEventListener('click', () => {
      let activeSlide = videoOpen.dataset.activeSlide;

      if (!videoModal.classList.contains('active')) {
        videoModal.classList.add('active');
      } else {
        videoModal.classList.remove('active');
      }

      window.videoReviewPopup.slideTo(activeSlide);

    })
  });
}

export function resetAndPauseVideo() {
  const video_array = document.querySelectorAll("[id^='main_video_popup_']")
  if (video_array.length == 0)
    return

  // set the pause button to display:none by default
  // update the progress bar
  video_array.forEach((video, index) => {
    const videoBlock = video.closest("[data-video-block]")

    video.pause();
    video.currentTime = 0;
    videoBlock.querySelector('.inner').style.width = 0;
    videoBlock.querySelector(".jc-play").classList.remove("jc-opacity-0");
    videoBlock.querySelector(".jc-play").classList.add("jc-opacity-100");
  })
}

export function videoReviewCarouselListener() {
  // Select the HTML5 video
  const video_array = document.querySelectorAll("[id^='main_video_popup_']")
  if (video_array.length == 0)
    return
  // set the pause button to display:none by default
  // update the progress bar
  video_array.forEach((video) => {
    const videoBlock = video.closest("[data-video-block]")
    video.addEventListener("timeupdate", () => {
      let curr = (video.currentTime / video.duration) * 100
      if (video.ended) {
        videoBlock.querySelector(".jc-play").classList.remove("jc-opacity-0")
        videoBlock.querySelector(".jc-play").classList.add("jc-opacity-100")
      }
      if (curr >= 99)
        curr = `100%`;
      else
        curr = `${curr}%`;
      videoBlock.querySelector('.inner').style.width = curr
    })

    videoBlock.querySelector(".jc-play").addEventListener("click", function (e) {
      // Condition when to play a video
      if (video.paused) {
        this.classList.add("jc-opacity-0");
        this.classList.remove("jc-opacity-100");
        video.play();
      }
      else {
        this.classList.remove("jc-opacity-0")
        this.classList.add("jc-opacity-100")
        video.pause()
      }
    })
    videoBlock.querySelector(".jc-timeline").addEventListener("click", function (e) {
      const progress = e.target.closest(".jc-timeline")
      if (progress) {
        var pos = (e.pageX - (progress.offsetLeft + progress.offsetParent.offsetLeft)) / progress.offsetWidth;
        video.currentTime = pos * video.duration;
      }
    })
  })

  const mute = document.querySelector(`#mute`);
  mute.addEventListener('click', function () {
    let muteState = mute.getAttribute('data-state');

    video_array.forEach((video) => {
      video.muted = !video.muted;
    })

    if (muteState === 'mute') {
      mute.setAttribute('data-state', 'unmute');
    } else {
      mute.setAttribute('data-state', 'mute');
    }
  });

  var vid = document.getElementsByClassName("swiper-hover-video");
  [].forEach.call(vid, function (item) {
    item.addEventListener('mouseover', hoverVideo, false);
    item.addEventListener('mouseout', hideVideo, false);
  });

  function hoverVideo(e) {
    this.previousElementSibling.muted = true;
    this.previousElementSibling.play();
    this.classList.add("jc-opacity-0");
    this.classList.add("-jc-z-10");
    this.classList.remove("jc-opacity-100");
    this.previousElementSibling.addEventListener("timeupdate", () => {
      if (this.currentTime >= 3) {
        this.currentTime = 0;
      }
    })
  }
  function hideVideo(e) {
    this.previousElementSibling.pause();
    this.previousElementSibling.currentTime = 0;
    this.classList.remove("jc-opacity-0");
    this.classList.remove("-jc-z-10");
    this.classList.add("jc-opacity-100");
    this.previousElementSibling.removeEventListener("timeupdate", () => { })
  }
}
